module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAABLUlEQVRoQ+2UPQ4BURRG753JayYWMDZhMQoKhZCoLUBBZwMahZ9EQxQ2Yh1YABoxV0QkCkPMR55JPq18z5xz3lDJ+Udz/vxCAN8FWYAFQAO8QqBAeM4CsELwABYABcJzFoAVggewQGaBQ3OxO8w0DBbberTKeo6fAkNzRXeci1jZRE4aBtWsEF4A4umxokmyuFtHILwAXB88nhy6atZDIbwBfAvCK8A3IFIBiqP9Ous/w6c7UympiHu8TqJBbdeIlu/OSgcY7+3d+Jffm8g5EGltmoXJq9/5W4DbQ2uiobY39WiQBvHnAFcGNTHrbJuF/jMI7y8xeg0JgBpE9yyAGkT3LIAaRPcsgBpE9yyAGkT3LIAaRPcsgBpE9yyAGkT3LIAaRPcsgBpE97kvcAFcU1AxT/wJUgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gotoCrow.png
// module id = nrK6
// module chunks = 1